import Add from "./Add";
import { AppProvider } from "./statesProvider/materialContext";

const MaterialIndex = () => {
  return (
    <AppProvider>
      <Add />
    </AppProvider>
  );
};

export default MaterialIndex;
